var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvenIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 75,
    viewBox: "0 0 80 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 75,
    fill: "url(#pattern0_263_1434)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_263_1434",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_263_1434",
    transform: "matrix(0.0104167 0 0 0.0111111 0.03125 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_263_1434",
    width: 90,
    height: 90,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAADxUlEQVR4nO3bz6uUVRzH8a+Kv80SF3ZvZZDLSBAKXKkLa2FBtGjtQrCNBZJkWNBFqK6oG3/eatcmNCKi8B8oTMVQXOjC3JQaRWl1vdculO84+F0M8czcc2ae5znnO31fMHCZe2bO9/O9Z56Z58xzRZxzzjnnnHPOOedcNGABsA+4SXluAOOhRrFOg5RuXKwrdCX/109iHUaIdRgh1mGEWJexdzPAG8Co3nbrfZXEOvLZXVFLaHYlsY58RipqebjbYLGOfEYranmk22CxjrIOHW92GyzWkc+MHpP9zbAkYl1C1qvAB3r7npaJdZE5DwILOx6zUO9rjVgXkfGdHo/t+rm3bmLdLPnGIh4/1sZhR6wbpMmRza7lsCPW1RWM6mYfSxzvjY5Rccz+BXgqYbw3OlbFSv0ZWJ0w3hsdq6J5OxPHe6NjAW8D94A/gbUR43s2W6xrMhjwOLAiYfxYk/VkVVowCqtnaINRWD1DG4zC6mk8WGnEOowQ6zBCrNMrNkt3XawzcjXp+zIk10ePF7qyy7w+Wvd6XwPOAHf0Fn5+tXNPeFiQI69efHKxx+q4EMbIkCBHXv3L9pq0c3LzK5tcefXlE2uHGEeuvMDZhIm/FePIlReYTJh4UowjV17gVsLEU2IcMJWQ97c6Jz5Nmi+AR8UY4DGtPcXXdRbwCunu6LfQ86RwwBxgO/BHHzm31X12l/IG0ek08LQUCnhGT0L6zTa/7oJGByjoHvAZ8KQUIlwPAnyutfXb5JGmigsru5u/I4r7B/gKeDa8XBspcvZDxHPAqcgG98rU7P5Ij4k3AD8S7zKwB3ii0YLv17wGeAu4klDfD5qpUtbv3ICVwAnSndVLATbWcUoLLAI2AXuBc33U80nIMlveRsVMDLw0wD/bT4ePTMCHwOvAFmBdWPn6h1ygexEr9b7wu+eBXcBHwDf6HP1um76Ymjdbo3XcUl2l05RvWvell/ebN1ujO8av1tX5F+W5C0yEE5W68tam34m5/1+r74VTVvL7FXgXWNVU3oENOjEwD9gMfKxnj22u3i+Bl1M+mg2at291Tgw8ALwAHAC+i/wsHis813lgv75ZLsudt5iJgYeA9cBWfWl/GvZ7gUvANd1FnNHbLb3vko45qY/Zqs/xYE01DV+jS+SNbok3uiXe6JZ4o1vijW5Jq3mBJcBR4PduEwO3gSPAYjGOXHl1PyDWhBhHjrzA3MQduPBV/Vwxilx5vdEt5k18KR0X48iVNxzwgcP6BtBN2Hs4NCRvhov/T3mdc84555xzzjnnJNG/ruwdIwIpkAYAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvenIcon);
export default __webpack_public_path__ + "static/media/EvenIcon.0a5b1dc18f082d478ca67b5d7f319bcf.svg";
export { ForwardRef as ReactComponent };